import styled from '@emotion/styled';
const resolveGroupHeaderFontSize = (size, theme) => {
  const map = {
    small: theme.tokens.ComponentListBoxGroupNameFontSizeSmall,
    sm: theme.tokens.ComponentListBoxGroupNameFontSizeSmall,
    medium: theme.tokens.ComponentListBoxGroupNameFontSizeMedium,
    md: theme.tokens.ComponentListBoxGroupNameFontSizeMedium,
    large: theme.tokens.ComponentListBoxGroupNameFontSizeLarge,
    lg: theme.tokens.ComponentListBoxGroupNameFontSizeLarge
  };
  return map[size];
};
export const ListGroupHeader = styled.span`
  color: ${props => props.theme.tokens.SemColorOnSurfaceMuted};
`;